import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import './assets/style/rest.css';
import 'animate.css';
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
